module.exports = __webpack_public_path__ + "img/Comoros.6ae3468c.svg";